// Auto-generated from icon.json
export default {
  "tagName": "ui-icon",
  "content": [
    "icon"
  ],
  "contentAttributes": [
    "icon"
  ],
  "variations": [
    "link",
    "fitted",
    "colored",
    "size",
    "spin",
    "inverted"
  ],
  "states": [
    "disabled",
    "loading"
  ],
  "settings": [
    "href",
    "target"
  ],
  "attributes": [
    "icon",
    "disabled",
    "loading",
    "link",
    "fitted",
    "colored",
    "size",
    "spin",
    "inverted",
    "href",
    "target"
  ],
  "optionAttributes": {
    "airplay": "icon",
    "alert-circle": "icon",
    "alert-octagon": "icon",
    "alert-triangle": "icon",
    "align-center": "icon",
    "align-justify": "icon",
    "align-left": "icon",
    "align-right": "icon",
    "anchor": "icon",
    "aperture": "icon",
    "archive": "icon",
    "arrow-down": "icon",
    "arrow-down-circle": "icon",
    "arrow-down-left": "icon",
    "arrow-down-right": "icon",
    "arrow-left": "icon",
    "arrow-left-circle": "icon",
    "arrow-right": "icon",
    "arrow-right-circle": "icon",
    "arrow-up": "icon",
    "arrow-up-circle": "icon",
    "arrow-up-left": "icon",
    "arrow-up-right": "icon",
    "at-sign": "icon",
    "award": "icon",
    "bar-chart": "icon",
    "bar-chart-2": "icon",
    "battery": "icon",
    "battery-charging": "icon",
    "bell": "icon",
    "bell-off": "icon",
    "bluetooth": "icon",
    "bold": "icon",
    "book": "icon",
    "book-open": "icon",
    "bookmark": "icon",
    "box": "icon",
    "briefcase": "icon",
    "calendar": "icon",
    "camera": "icon",
    "camera-off": "icon",
    "cast": "icon",
    "check": "icon",
    "check-circle": "icon",
    "check-square": "icon",
    "chevron-down": "icon",
    "chevron-left": "icon",
    "chevron-right": "icon",
    "chevron-up": "icon",
    "chevrons-down": "icon",
    "chevrons-left": "icon",
    "chevrons-right": "icon",
    "chevrons-up": "icon",
    "chrome": "icon",
    "circle": "icon",
    "clipboard": "icon",
    "clock": "icon",
    "cloud": "icon",
    "cloud-drizzle": "icon",
    "cloud-lightning": "icon",
    "cloud-off": "icon",
    "cloud-rain": "icon",
    "cloud-snow": "icon",
    "code": "icon",
    "codepen": "icon",
    "codesandbox": "icon",
    "coffee": "icon",
    "columns": "icon",
    "command": "icon",
    "compass": "icon",
    "copy": "icon",
    "corner-down-left": "icon",
    "corner-down-right": "icon",
    "corner-left-down": "icon",
    "corner-left-up": "icon",
    "corner-right-down": "icon",
    "corner-right-up": "icon",
    "corner-up-left": "icon",
    "corner-up-right": "icon",
    "cpu": "icon",
    "credit-card": "icon",
    "crop": "icon",
    "crosshair": "icon",
    "currentColor": "icon",
    "database": "icon",
    "delete": "icon",
    "disc": "icon",
    "divide": "icon",
    "divide-circle": "icon",
    "divide-square": "icon",
    "dollar-sign": "icon",
    "download": "icon",
    "download-cloud": "icon",
    "dribbble": "icon",
    "droplet": "icon",
    "edit": "icon",
    "edit-2": "icon",
    "edit-3": "icon",
    "external-link": "icon",
    "eye": "icon",
    "eye-off": "icon",
    "facebook": "icon",
    "fast-forward": "icon",
    "feather": "icon",
    "figma": "icon",
    "file": "icon",
    "file-minus": "icon",
    "file-plus": "icon",
    "file-text": "icon",
    "film": "icon",
    "filter": "icon",
    "flag": "icon",
    "folder": "icon",
    "folder-minus": "icon",
    "folder-plus": "icon",
    "framer": "icon",
    "frown": "icon",
    "github": "icon",
    "gitlab": "icon",
    "globe": "icon",
    "grid": "icon",
    "hard-drive": "icon",
    "hash": "icon",
    "headphones": "icon",
    "heart": "icon",
    "help-circle": "icon",
    "hexagon": "icon",
    "home": "icon",
    "image": "icon",
    "inbox": "icon",
    "info": "icon",
    "instagram": "icon",
    "italic": "icon",
    "key": "icon",
    "layers": "icon",
    "layout": "icon",
    "life-buoy": "icon",
    "linkify": "icon",
    "linkify-2": "icon",
    "linkedin": "icon",
    "list": "icon",
    "loader": "icon",
    "lock": "icon",
    "log-in": "icon",
    "log-out": "icon",
    "mail": "icon",
    "map": "icon",
    "map-pin": "icon",
    "maximize": "icon",
    "maximize-2": "icon",
    "meh": "icon",
    "menu": "icon",
    "message-circle": "icon",
    "message-square": "icon",
    "mic": "icon",
    "mic-off": "icon",
    "minimize": "icon",
    "minimize-2": "icon",
    "minus": "icon",
    "minus-circle": "icon",
    "minus-square": "icon",
    "monitor": "icon",
    "moon": "icon",
    "more-horizontal": "icon",
    "more-vertical": "icon",
    "mouse-pointer": "icon",
    "move": "icon",
    "music": "icon",
    "navigation": "icon",
    "navigation-2": "icon",
    "octagon": "icon",
    "package": "icon",
    "paperclip": "icon",
    "pause": "icon",
    "pause-circle": "icon",
    "pen-tool": "icon",
    "percent": "icon",
    "phone": "icon",
    "phone-call": "icon",
    "phone-forwarded": "icon",
    "phone-incoming": "icon",
    "phone-missed": "icon",
    "phone-off": "icon",
    "phone-outgoing": "icon",
    "pie-chart": "icon",
    "play": "icon",
    "play-circle": "icon",
    "plus": "icon",
    "plus-circle": "icon",
    "plus-square": "icon",
    "pocket": "icon",
    "power": "icon",
    "printer": "icon",
    "radio": "icon",
    "refresh-ccw": "icon",
    "refresh-cw": "icon",
    "repeat": "icon",
    "rewind": "icon",
    "rotate-ccw": "icon",
    "rotate-cw": "icon",
    "rss": "icon",
    "save": "icon",
    "scissors": "icon",
    "search": "icon",
    "send": "icon",
    "server": "icon",
    "settings": "icon",
    "share": "icon",
    "share-2": "icon",
    "shield": "icon",
    "shield-off": "icon",
    "shopping-bag": "icon",
    "shopping-cart": "icon",
    "shuffle": "icon",
    "sidebar": "icon",
    "skip-back": "icon",
    "skip-forward": "icon",
    "slack": "icon",
    "slash": "icon",
    "sliders": "icon",
    "smartphone": "icon",
    "smile": "icon",
    "speaker": "icon",
    "square": "icon",
    "star": "icon",
    "stop-circle": "icon",
    "sun": "icon",
    "sunrise": "icon",
    "sunset": "icon",
    "table": "icon",
    "tablet": "icon",
    "tag": "icon",
    "target": "icon",
    "terminal": "icon",
    "thermometer": "icon",
    "thumbs-down": "icon",
    "thumbs-up": "icon",
    "toggle-left": "icon",
    "toggle-right": "icon",
    "tool": "icon",
    "trash": "icon",
    "trash-2": "icon",
    "trello": "icon",
    "trending-down": "icon",
    "trending-up": "icon",
    "triangle": "icon",
    "truck": "icon",
    "tv": "icon",
    "twitch": "icon",
    "twitter": "icon",
    "type": "icon",
    "umbrella": "icon",
    "underline": "icon",
    "unlock": "icon",
    "upload": "icon",
    "upload-cloud": "icon",
    "user": "icon",
    "user-check": "icon",
    "user-minus": "icon",
    "user-plus": "icon",
    "user-x": "icon",
    "users": "icon",
    "video": "icon",
    "video-off": "icon",
    "voicemail": "icon",
    "volume": "icon",
    "volume-1": "icon",
    "volume-2": "icon",
    "volume-x": "icon",
    "watch": "icon",
    "wifi": "icon",
    "wifi-off": "icon",
    "wind": "icon",
    "x": "icon",
    "x-circle": "icon",
    "x-octagon": "icon",
    "x-square": "icon",
    "youtube": "icon",
    "zap": "icon",
    "zap-off": "icon",
    "zoom-in": "icon",
    "zoom-out": "icon",
    "red": "colored",
    "orange": "colored",
    "yellow": "colored",
    "olive": "colored",
    "green": "colored",
    "teal": "colored",
    "blue": "colored",
    "violet": "colored",
    "purple": "colored",
    "pink": "colored",
    "brown": "colored",
    "grey": "colored",
    "black": "colored",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size"
  },
  "propertyTypes": {
    "icon": "string",
    "disabled": "boolean",
    "loading": "boolean",
    "link": "boolean",
    "fitted": "boolean",
    "colored": "string",
    "size": "string",
    "spin": "boolean",
    "inverted": "boolean",
    "href": "string",
    "target": "string"
  },
  "allowedValues": {
    "icon": [
      "airplay",
      "alert-circle",
      "alert-octagon",
      "alert-triangle",
      "align-center",
      "align-justify",
      "align-left",
      "align-right",
      "anchor",
      "aperture",
      "archive",
      "arrow-down",
      "arrow-down-circle",
      "arrow-down-left",
      "arrow-down-right",
      "arrow-left",
      "arrow-left-circle",
      "arrow-right",
      "arrow-right-circle",
      "arrow-up",
      "arrow-up-circle",
      "arrow-up-left",
      "arrow-up-right",
      "at-sign",
      "award",
      "bar-chart",
      "bar-chart-2",
      "battery",
      "battery-charging",
      "bell",
      "bell-off",
      "bluetooth",
      "bold",
      "book",
      "book-open",
      "bookmark",
      "box",
      "briefcase",
      "calendar",
      "camera",
      "camera-off",
      "cast",
      "check",
      "check-circle",
      "check-square",
      "chevron-down",
      "chevron-left",
      "chevron-right",
      "chevron-up",
      "chevrons-down",
      "chevrons-left",
      "chevrons-right",
      "chevrons-up",
      "chrome",
      "circle",
      "clipboard",
      "clock",
      "cloud",
      "cloud-drizzle",
      "cloud-lightning",
      "cloud-off",
      "cloud-rain",
      "cloud-snow",
      "code",
      "codepen",
      "codesandbox",
      "coffee",
      "columns",
      "command",
      "compass",
      "copy",
      "corner-down-left",
      "corner-down-right",
      "corner-left-down",
      "corner-left-up",
      "corner-right-down",
      "corner-right-up",
      "corner-up-left",
      "corner-up-right",
      "cpu",
      "credit-card",
      "crop",
      "crosshair",
      "currentColor",
      "database",
      "delete",
      "disc",
      "divide",
      "divide-circle",
      "divide-square",
      "dollar-sign",
      "download",
      "download-cloud",
      "dribbble",
      "droplet",
      "edit",
      "edit-2",
      "edit-3",
      "external-link",
      "eye",
      "eye-off",
      "facebook",
      "fast-forward",
      "feather",
      "figma",
      "file",
      "file-minus",
      "file-plus",
      "file-text",
      "film",
      "filter",
      "flag",
      "folder",
      "folder-minus",
      "folder-plus",
      "framer",
      "frown",
      "github",
      "gitlab",
      "globe",
      "grid",
      "hard-drive",
      "hash",
      "headphones",
      "heart",
      "help-circle",
      "hexagon",
      "home",
      "image",
      "inbox",
      "info",
      "instagram",
      "italic",
      "key",
      "layers",
      "layout",
      "life-buoy",
      "linkify",
      "linkify-2",
      "linkedin",
      "list",
      "loader",
      "lock",
      "log-in",
      "log-out",
      "mail",
      "map",
      "map-pin",
      "maximize",
      "maximize-2",
      "meh",
      "menu",
      "message-circle",
      "message-square",
      "mic",
      "mic-off",
      "minimize",
      "minimize-2",
      "minus",
      "minus-circle",
      "minus-square",
      "monitor",
      "moon",
      "more-horizontal",
      "more-vertical",
      "mouse-pointer",
      "move",
      "music",
      "navigation",
      "navigation-2",
      "octagon",
      "package",
      "paperclip",
      "pause",
      "pause-circle",
      "pen-tool",
      "percent",
      "phone",
      "phone-call",
      "phone-forwarded",
      "phone-incoming",
      "phone-missed",
      "phone-off",
      "phone-outgoing",
      "pie-chart",
      "play",
      "play-circle",
      "plus",
      "plus-circle",
      "plus-square",
      "pocket",
      "power",
      "printer",
      "radio",
      "refresh-ccw",
      "refresh-cw",
      "repeat",
      "rewind",
      "rotate-ccw",
      "rotate-cw",
      "rss",
      "save",
      "scissors",
      "search",
      "send",
      "server",
      "settings",
      "share",
      "share-2",
      "shield",
      "shield-off",
      "shopping-bag",
      "shopping-cart",
      "shuffle",
      "sidebar",
      "skip-back",
      "skip-forward",
      "slack",
      "slash",
      "sliders",
      "smartphone",
      "smile",
      "speaker",
      "square",
      "star",
      "stop-circle",
      "sun",
      "sunrise",
      "sunset",
      "table",
      "tablet",
      "tag",
      "target",
      "terminal",
      "thermometer",
      "thumbs-down",
      "thumbs-up",
      "toggle-left",
      "toggle-right",
      "tool",
      "trash",
      "trash-2",
      "trello",
      "trending-down",
      "trending-up",
      "triangle",
      "truck",
      "tv",
      "twitch",
      "twitter",
      "type",
      "umbrella",
      "underline",
      "unlock",
      "upload",
      "upload-cloud",
      "user",
      "user-check",
      "user-minus",
      "user-plus",
      "user-x",
      "users",
      "video",
      "video-off",
      "voicemail",
      "volume",
      "volume-1",
      "volume-2",
      "volume-x",
      "watch",
      "wifi",
      "wifi-off",
      "wind",
      "x",
      "x-circle",
      "x-octagon",
      "x-square",
      "youtube",
      "zap",
      "zap-off",
      "zoom-in",
      "zoom-out"
    ],
    "colored": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "black"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ]
  },
  "defaultValues": {
    "href": "",
    "target": ""
  }
};
